'use client';

import { createContext } from 'react';

import type { PhotoCarouselRootContextInterface } from '../types/photo-carousel-root.types';

export const PhotoCarouselRootContext = createContext<PhotoCarouselRootContextInterface>({
  activeIndex: 0,
  id: '',
  navigationDirection: 0,
  setTotalSlides: () => {},
  shouldLoop: true,
  totalSlides: 0,
  updateActiveIndex: () => {},
});

PhotoCarouselRootContext.displayName = 'PhotoCarousel.Root.Context';
